import ReactOnRails from 'react-on-rails';
import '../src/styles/privacy-page.sass';
import PrivacyPage from "../bundles/PrivacyPage";

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({ PrivacyPage });
